import _ from 'lodash';

class SettingsController {
  constructor(UsersService, OfficesService) {
    'ngInject';
    Object.assign(this, {UsersService});
    this.credentials = {};
    this.user = UsersService.currentUser();
    // load offices, used when logged in
    OfficesService.list().then((offices) => this.offices = _.keyBy(offices, 'id'));
  }

  loginUser() {
    this.UsersService.login(this.credentials).then((user) => {
      console.debug('Logged in as', user);
      this.user = user;
      this.loginFailed = false;
    }).catch(() => {
      this.loginFailed = true;
    });
  }

  logoutUser() {
    this.UsersService.logout().then(() => {
      this.user = null;
      this.credentials = {};
    });
  }

  isStarred(office) {
    return _.includes(this.user.starredOffices, office.id);
  }

  toggleOffice(office) {
    if (this.isStarred(office)) {
      this.user.starredOffices = _.without(this.user.starredOffices, office.id);
    } else {
      this.user.starredOffices.push(office.id);
    }
    // update user in local storage
    this.UsersService.saveCurrentUser(this.user);
  }

}

export default SettingsController;



// WEBPACK FOOTER //
// ./client/app/components/settings/settings.controller.js